export default {"src":"/_next/static/media/features-exclusive-playlist.297c331d.gif","height":300,"width":400};